export const members = [
    // 기획자
    {
      id: "pm-01",
      category: "Product Manager",
      major: "Multimedia",
    
      name: "곽민지",
      role: "에버랜드",
      position: "UI/UX 기획자",
    
      images: {
        product: "productmanager/kwakminji/product-img.jpg",
        profile: "productmanager/kwakminji/profile-img.png",
        panel: "productmanager/kwakminji/panel-img-min.jpg",
      },
    
      links: {
        presentation: "https://youtu.be/9dTtJ-iQW1U?si=-Pz3GnYt4pZ0bWqk",  
        intro: "https://youtu.be/5-Dc0p4-91A?si=FrLZ0SYFGJSVmOyH",        
      },
    
      about: "최근 테마파크 산업은 IP와 디지털 융합을 통한 몰입 경험이 핵심 경쟁력으로 부상하고 있습니다. 이에 에버랜드는 단순 예매 중심 구조에서 벗어나, 방문 전부터 후까지 이어지는 고객 여정을 통합 관리하는 플랫폼으로 전환하여, 이를 통해 이용 편의성과 브랜드 일관성을 강화하고, 지속적으로 확장 가능한 디지털 경험을 실현하고자 합니다. ",
      phone: "010-2982-0718",
      email: "alswl2413@naver.com",
    },

    {
      id: "pm-2",
      category: "Product Manager",
      major: "Multimedia",
    
      name: "구본희",
      role: "NH스마트뱅킹&NH인터넷뱅킹",
      position: "UI/UX 기획자",
    
      images: {
        product: "productmanager/koobonhui/product-img.jpg",
        profile: "productmanager/koobonhui/profile-img.png",
        panel: "productmanager/koobonhui/panel-img-min.jpg",
      },
    
      links: {
        presentation: "https://youtu.be/JLWxFS7P03g?si=EHKmhPbUIRqCSqnC",  
        intro: "https://youtu.be/QbK6Nj0AIIY?si=s3lp8DiGvokItbLJ",        
      },
    
      about: "NH농협은행은 15~39세 대상 조사에서 타 금융권보다 높은 브랜드 신뢰도를 보이며, 세대가 달라져도 변함없이 ‘신뢰할 수 있는 금융 브랜드’로 인식됩니다. 이러한 안정성과 투명한 운영을 기반으로, 변화하는 금융 환경 속에서도 일관된 가치와 사용자 중심 철학을 유지하며, 신뢰를 토대로 한 ‘안전한 혁신’을 통해 새로운 세대가 공감할 수 있는 디지털 금융 경험을 제안합니다.",
      phone: "010-3690-7855",
      email: "bons011207@naver.com",
    }, 

    {
      id: "pm-03",
      category: "Product Manager",
      major: "Multimedia",
    
      name: "김수민",
      role: "InBody",
      position: "UI/UX 기획자",
    
      images: {
        product: "productmanager/kimsoomin/product-img.jpg",
        profile: "productmanager/kimsoomin/profile-img.png",
        panel: "productmanager/kimsoomin/panel-img-min.jpg",
      },
    
      links: {
        presentation: "https://youtu.be/bYxn1QUr3DY?si=Y1qwleW-SiFBGAr2",  
        intro: "https://youtu.be/xHhP-HdeRQs?si=b6MKO4uaxmfKXRZ1",        
      },
    
      about: "InBody는 단순한 신체 측정을 넘어, 개인의 데이터를 중심으로 전방위적 건강 행동을 설계하는 플랫폼으로 확장하고자 합니다. AI 분석을 통해 체성분 변화와 생활 루틴을 연결하고, 사용자가 목표를 설정하며 성장하는 자율형 헬스케어 경험을 제공합니다. 데이터 기반의 인사이트와 맞춤 피드백을 지속 가능한 웰니스로 완성하는 사용자 중심 헬스케어 플랫폼을 제안합니다.",
      phone: "010-3240-7217",
      email: "chel1102@kakao.com",
    }, 

    {
      id: "pm-04",
      category: "Product Manager",

      major: "Multimedia",
    
      name: "김은서",
      role: "이마트몰",
      position: "UI/UX 기획자",
    
      images: {
        product: "productmanager/kimeunseo/product-img.jpg",
        profile: "productmanager/kimeunseo/profile-img.png",
        panel: "productmanager/kimeunseo/panel-img-min.jpg",
      },
    
      links: {
        presentation: "",  
        intro: "https://youtu.be/3SHyWFFEeiw?si=8UoWcwY2_jFolYxB",        
      },
    
      about: "다양한 카테고리와 방대한 상품정보로 인해 사용자가 원하는 정보를 한눈에 파악하기 어려운 한계가 존재, 이에따라 사용자가 더쉽고 직관적으로 앱을 탐색할수 있는 환경을 제공하고자 합니다. 맞춤형 추천 등의 기능을 강화해 사용자 제공 특히 단순하고 명확한 UX를 중심으로한 화면 구성, 그리고 빠른검색과 구매 가 가능한 플로우구축을 제안합니다.",
      phone: "010-6844-4750",
      email: "rlaeunseo@kakao.com",
    },

    {
      id: "pm-05",
      category: "Product Manager",
      major: "Multimedia",
    
      name: "김진우",
      role: "현대해상",
      position: "UI/UX 기획자",
    
      images: {
        product: "productmanager/kimjinwoo/product-img.jpg",
        profile: "productmanager/kimjinwoo/profile-img.png",
        panel: "productmanager/kimjinwoo/panel-img-min.jpg",
      },
    
      links: {
        presentation: "https://youtu.be/vtV-I4mpIkw?si=PjGBwvyA4pkqvehD",  
        intro: "https://youtu.be/4N4r7gkMyjY?si=HXlzCDkqBA6NAZ9A",        
      },
    
      about: "보험의 디지털 전환 흐름과 사용자 경험 변화를 기반으로, 웹 앱 통합 리뉴얼을 제시합니다. 데이터 중심의 개인화, 오픈파이낸스, AI 기반 보험 관리 자동화를 통해 사용자가 스스로 활용할 수 있는 환경을 제공합니다. 예측성, 연속성, 맞춤성의 전략으로 보험의 처음부터 끝까지 끊김없는 경험을 제공해 신뢰와 혁신의 가치를 담은 차세대 인슈어 테크 플랫폼을 제안합니다.",
      phone: "010-9931-3921",
      email: "st993151@naver.com",
    },

    {
      id: "pm-06",
      category: "Product Manager",
      major: "Multimedia",
    
      name: "김현정",
      role: "현대백화점",
      position: "UI/UX 기획자",
    
      images: {
        product: "productmanager/kimhyunjung/pruduct-img.jpg",
        profile: "productmanager/kimhyunjung/profile-img.png",
        panel: "productmanager/kimhyunjung/panel-img-min.jpg",
      },
    
      links: {
        presentation: "https://youtu.be/k4bQwFzX80U?si=1jvckFQkylmqjPBJ",  
        intro: "https://youtu.be/g09e6yo1pIU?si=ww_5juC5QDSDQhBV",        
      },
    
      about: "현대백화점은 온·오프라인을 넘나드는 고객 여정에 맞춰, 오프라인 중심 경험만으로는 기대를 충족하기 어려운 시점에 이르렀습니다. 고객은 정보 탐색을 넘어 몰입감 있는 콘텐츠와 개인화된 환경을 원하고 있습니다. 이에 디지털 환경에서도 일관된 브랜드 경험을 제공하며, 온·오프라인을 아우르는 통합 UX로 지속적인 교감을 형성하는 차별화된 쇼핑 플랫폼을 제안합니다.",
      phone: "010-9309-2066",
      email: "mary3033@naver.com",
    },

    {
      id: "pm-07",
      category: "Product Manager",
      major: "Multimedia",
    
      name: "문태환",
      role: "KB Pay",
      position: "UI/UX 기획자",
    
      images: {
        product: "productmanager/moontaehwan/product-img.jpg",
        profile: "productmanager/moontaehwan/profile-img.png",
        panel: "productmanager/moontaehwan/panel-img-min.jpg",
      },
    
      links: {
        presentation: "https://youtu.be/9CRI9VXKT-M?si=YAJ52QQd1l5XtEVg",  
        intro: "https://youtu.be/5J4ifzarK_Y?si=qjJzGywAhvaEl-y6",        
      },
    
      about: "KB Pay는 개인의 요구와 선호를 충족시키는 AI 기반 맞춤형 서비스의 중요성이 커지고 있는 흐름에 맞춰, AI 기술을 중심으로 한 초개인화 서비스와 결제 프로세스 최적화를 통해 사용자에게 빠르고 간편한 결제 경험 제공하며 나아가 사용자 중심의 직관적 결제 경험을 구현함으로써, 금융 생활의 새로운 기준을 제시하는 4세대 간편결제 플랫폼으로의 도약을 제안합니다.",
      phone: "010-9262-4732",
      email: "xoghksehdsp@kakao.com",
    },

    {
      id: "pm-08",
      category: "Product Manager",
      major: "Multimedia",
    
      name: "박수진",
      role: "11번가",
      position: "UI/UX 기획자",
    
      images: {
        product: "productmanager/parksujin/product-img.jpg",
        profile: "productmanager/parksujin/profile-img.png",
        panel: "productmanager/parksujin/panel-img-min.jpg",
      },
    
      links: {
        presentation: "https://youtu.be/3zoj9PTbego?si=WfKKUMXdnoCL5dZK",  
        intro: "https://youtu.be/gUXtD-QCMc8?si=3RGjS1kRdimW-qLG",        
      },
    
      about: "11번가는 AI 기반 개인화 큐레이션과 실시간 데이터 분석을 결합한 몰입형 커머스 플랫폼으로, 사용자의 취향과 맥락을 이해하여 상황별 맞춤형 쇼핑 경험을 제공한다. 본 리뉴얼은 앱과 웹의 연동성을 강화하고, 콘텐츠 중심의 탐색 구조와 AI 리뷰 요약, 쇼핑 어시스턴트 기능을 통해 탐색 효율과 브랜드 경험을 동시에 향상시키는 차세대 개인화 커머스 플랫폼을 제안합니다.",
      phone: "010-9282-3978",
      email: "toatoa0249@gmail.com",
    }, 

    {
      id: "pm-09",
      category: "Product Manager",
      major: "Multimedia",
    
      name: "박원빈",
      role: "KB국민은행&KB스타뱅킹",
      position: "UI/UX 기획자",
    
      images: {
        product: "productmanager/bakwonbin/product-img.jpg",
        profile: "productmanager/bakwonbin/profile-img.png",
        panel: "productmanager/bakwonbin/panel-img-min.jpg",
      },
    
      links: {
        presentation: "https://youtu.be/sCM2J92XC-U?si=wMraGgiLtoQwjbal",  
        intro: "https://youtu.be/4wAQuWlZAQ8?si=bVP8jnqBwGnU8sMm",        
      },
    
      about: "현재 KB국민은행은 디지털 금융 환경 변화에 따라 기능 중심의 단편적 서비스 제공을 넘어서야 합니다. 사용자에게 편리한 기능성, 누구나 쉽게 접근 가능한 구조, 반복 사용을 유도하는 편리한 사용성을 재정비하고, 데이터 기반의 개인화된 콘텐츠를 강화해야 합니다. 기능, 접근, 사용 측면에서 모두 뛰어난 사용자 중심 디지털 금융 플랫폼으로의 전환을 제안합니다.",
      phone: "010-5594-4585",
      email: "dnjsqls0620@kakao.com",
    },

    {
      id: "pm-10",
      category: "Product Manager",
      major: "Multimedia",
    
      name: "이지혁",
      role: "풀무원",
      position: "UI/UX 기획자",
    
      images: {
        product: "productmanager/leejihyeok/product-img.jpg",
        profile: "productmanager/leejihyeok/profile-img.png",
        panel: "productmanager/leejihyeok/panel-img-min.jpg",
      },
    
      links: {
        presentation: "https://youtu.be/ntY3jsqED60?si=UM4kUbfCZVrDPjeO",  
        intro: "https://youtu.be/ftLOZ2ZR8NU?si=CF5MGSSbUWEa0Wp-",        
      },
    
      about: "현재 식품·헬스케어 시장은 개인 맞춤형 서비스와 데이터 기반 통합 플랫폼으로 빠르게 전환되고 있습니다. 풀무원은 건강 데이터와 소비 데이터를 연결해 사용자의 일상 속 지속 가능한 루틴을 완성하는 라이프케어 커머스 플랫폼으로 도약합니다. 개인화된 피드백과 통합 UX를 통해 브랜드 신뢰와 이용 지속성을 강화할 수 있는 방향을 제안합니다.",
      phone: "010-4967-4220",
      email: "dlwlgur15@kakao.com",
    }, 

    {
      id: "pm-11",
      category: "Product Manager",
      major: "Multimedia",
    
      name: "이현정",
      role: "우리카드",
      position: "UI/UX 기획자",
    
      images: {
        product: "productmanager/leehyunjeong/product-img.jpg",
        profile: "productmanager/leehyunjeong/profile-img.png",
        panel: "productmanager/leehyunjeong/panel-img-min.jpg",
      },
    
      links: {
        presentation: "https://youtu.be/i9uq6CkVPd4?si=JeHA_2kgN-_ALx_P",  
        intro: "https://youtu.be/zfZJKrxCVTI?si=HZIae4Uja-dGaE-d",        
      },
    
      about: "간편결제의 확산과 디지털 금융의 일상화로 결제 경험의 중심이 빠르게 변화하고 있습니다. 사용자는 단순한 결제를 넘어 소비 패턴에 맞춘 개인화된 금융 경험을 기대하고 있습니다. 이에 AI와 데이터 분석을 기반으로 한 초개인화 서비스를 도입하고, 보다 직관적이고 편리한 흐름으로 금융 여정을 재구성하는 UX/UI 리뉴얼 방향을 제안합니다.",
      phone: "010-7795-3649",
      email: "dlguswjd36499@naver.com",
    },


    {
      id: "pm-12",
      category: "Product Manager",
      major: "Multimedia",
    
      name: "최은빈",
      role: "하나투어",
      position: "UI/UX 기획자",
    
      images: {
        product: "productmanager/choieunbin/product-img.jpg",
        profile: "productmanager/choieunbin/profile-img.png",
        panel: "productmanager/choieunbin/panel-img-min.jpg",
      },
    
      links: {
        presentation: "https://youtu.be/nFtZOK6uhUs?si=V2oPDo4hIy1yJA8n",  
        intro: "https://youtu.be/wOwEjGzoxGo?si=ShX26ew4DgBZinri",        
      },
    
      about: "하나투어는 여행의 탐색–비교–예약–여행 중을 하나의 흐름으로 연결하는 개인화 기반 여행 서비스로의 전환이 필요합니다. 카드형 정보 구조와 상단 고정 내비게이션으로 탐색 시간을 줄이고,통합 프로필, 실시간 데이터를 기반으로 알림들을 자동 연동 하며, 여행중 홈과 AI 기반 추천으로 상황에 맞는 일정과 정보를 제공하는 사용자 중심 여행 경험을 제안합니다.",
      phone: "010-4542-7081",
      email: "chld5105@kakao.com",
    },

    {
      id: "pm-13",
      category: "Product Manager",
      major: "Multimedia",
    
      name: "최혁주",
      role: "스타필드",
      position: "UI/UX 기획자",
    
      images: {
        product: "productmanager/choihyukju/product-img.jpg",
        profile: "productmanager/choihyukju/profile-img.png",
        panel: "productmanager/choihyukju/panel-img-min.jpg",
      },
    
      links: {
        presentation: "https://youtu.be/v-AIgmf3q4I?si=pa_h8tPWXsbB19il",  
        intro: "https://youtu.be/1onZDQsrtKA?si=pwhzEeaZucLBWRWk",        
      },
      
      about: "복합문화공간 시장은 경험 중심 소비와 디지털 전환이 확산되며, 고객은 여가·쇼핑·체험을 하나로 연결한 몰입형 서비스를 기대합니다. 이에 스타필드는 AI 개인화 서비스와 O4O 전략을 통해 방문 전·중·후를 잇는 끊김 없는 여정과 맞춤형 체류 경험을 제공하며, 사용자 행동과 관심에 따라 유동적으로 변화하는 고객 중심 디지털 플랫폼을 제안합니다.",
      phone: "010-6387-2473",
      email: "gurwn0904@naver.com",
    },
     
    {
      id: "pm-14",
      category: "Product Manager",
      major: "Multimedia",
    
      name: "추강현",
      role: "HANSSEM",
      position: "기획자",
    
      images: {
        product: "productmanager/chukanghyun/product-img.jpg",
        profile: "productmanager/chukanghyun/profile-img.png",
        panel: "productmanager/chukanghyun/panel-img-min.jpg",
      },
    
      links: {
        presentation: "https://youtu.be/gjOYRLtpnLg?si=AibkW59pMgLL-QUQ",  
        intro: "https://youtu.be/Ig2CtRz76LI?si=ra778pwCjIBnAw4I",        
      },
    
      about: "한샘은 가구판매 중심의 구조를 넘어,AI기반의 개인화 케어 리포트 서비스로 진화 하는 생활관리형 브랜드로 전환 하고 이를 위해 통합UX 데이터 활용, 지속가능성 강화가 핵심 전략 방향이 되어야 하고 가구,인테리어 공급을 넘어,고객의삶의 질을 높이는 라이프 스타일 플랫폼으로 확고히 자리 매김할 것으로 전망하고 제안하고자 합니다.",
      phone: "010-6818-1191",
      email: "kang911936@gmail.com",
    }, 

    {
      id: "pm-15",
      category: "Product Manager",
      major: "Multimedia",
    
      name: "허선범",
      role: "우리은행&우리WON뱅킹",
      position: "UI/UX 기획자",
    
      images: {
        product: "productmanager/heoseonbeom/product-img.jpg",
        profile: "productmanager/heoseonbeom/profile-img.png",
        panel: "productmanager/heoseonbeom/panel-img-min.jpg",
      },
    
      links: {
        presentation: "https://youtu.be/FgtPIlp5gAk?si=ON8C0SRl9Gmx8lha",  
        intro: "https://youtu.be/85qRWB4UIOk?si=Lkmj6RHG2LWZA2FT",        
      },
    
      about: "우리은행이 개인의 금융 소비 경험을 단순한 거래를 넘어, 일상과 금융이 유기적으로 연결된 지속 가능한 서비스를 위해 맞춤형 정보 제공과 전문성 기반의 금융 서비스를 제공할 수 있도록 하였습니다. 이로써 편리하고 효율적인 금융•일상생활 경험을 제공함과 동시에 지속적인 금융 서비스 사용을 유도할 수 있는 사용자 맞춤형 통합 금융 플랫폼으로의 진화를 제안합니다.",
      phone: "010-6429-9757",
      email: "sb9757@kakao.com",
    }, 

    {
      id: "pm-16",
      category: "Product Manager",
      major: "Multimedia",
  
      name: "황재하",
      role: "LG U+",
      position: "UI/UX 기획자",
  
      images: {
        product: "productmanager/hwangjaeha/product-img.jpg",
        profile: "productmanager/hwangjaeha/profile-img.png",
        panel: "productmanager/hwangjaeha/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/r8CGPN-6D5I?si=PkNDNyalEMZg9SpJ",  
        intro: "https://youtu.be/uuMSCsR_d8M?si=wSHf3i92dvx9Itny",        
      },
  
      about: "이동통신 시장은 최근 유심 사고로 인한 신뢰 적하를 겪으며 이용자들은 단순한 요금 관리보다 안전하고 신뢰할 수 있는 서비스 경험을 요구하고 있으며, 동시에 AI기술이 산업 전반의 핵심이 되어 통신 플랫폼은 이제 개인화·자동화 중심의 지능형 서비스로 전환되고 있습니다. 이에 LG U+는 AI와 보안 강화를 결합해 사용자 중심의 스마트 통신 경험 플랫폼을 제안합니다.",
      phone: "010-6430-0607",
      email: "ys010607@kakao.com",
    },
    
    // 개발자
    {
      id: "dev-01",
      category: "Developer",
      major: "Multimedia",
  
      name: "이인준",
      role: "롯데호텔&리조트",
      position: "개발자",
  
      images: {
        product: "developer/leeinjun/product-img.jpg",
        profile: "developer/leeinjun/profile-img.png",
        panel: "developer/leeinjun/panel-img-min.jpg",
      },
  
      links: {
        intro: "https://youtu.be/vbiKzKdyjdY?si=YeNgGATfB4sYOfr5",
      },
  
      about:
        "호텔 예약과 고객 문의 과정에서 반복적인 응대와 정보 확인으로 업무 효율이 저하되고 있습니다. 사용자는 여러 채널을 오가며 필요한 정보를 직접 찾아야 하는 불편을 겪고 있습니다. 이에 고객의 이용 편의를 높이고 일관된 브랜드 경험을 제공하며, 데이터 기반으로 고객 요구를 분석·개선하고 맞춤형 서비스를 강화할 수 있는 지능형 통합 고객지원 시스템 구축을 제안합니다.",
  
      phone: "010-7942-6502",
      email: "injoon0526@kakao.com",
    },

    {
      id: "dev-02",
      category: "Developer",
      major: "Multimedia",
  
      name: "임형근",
      role: "롯데월드",
      position: "개발자",
  
      images: {
        product: "developer/limhyeonggeun/product-img.jpg",
        profile: "developer/limhyeonggeun/profile-img.png",
        panel: "developer/limhyeonggeun/panel-img-min.jpg",
      },
  
      links: {
        intro: "https://youtu.be/AkpNSW478Aw?si=qQs8MXFbm5V2s2Xm",
      },
  
      about:
        "롯데월드는 예매, 입장, 공연 알림 등 다양한 이용 서비스를 하나로 통합한 스마트 테마파크 플랫폼으로, 실시간 운영 관리와 맞춤형 정보 제공을 통해 사용자 편의성과 몰입도를 높이고 있다. 본 시스템은 관리자 기능을 통해 알림·티켓·콘텐츠를 효율적으로 관리하고, 데이터 기반 운영으로 서비스 품질과 이용자 경험을 함께 향상시키는 차세대 통합 관리 플랫폼을 제안합니다.",
  
      phone: "010-4168-5269",
      email: "lhg010115@kakao.com",
    },

    {
      id: "dev-03",
      category: "Developer",
      major: "Multimedia",
    
      name: "유현빈, 이기원",
      role: "Gun & Fire",
      position: "락온",
    
      images: {
        product: "developer/lockon/product-img.jpg",
        profile: "developer/lockon/profile-img.png",
        panel: "developer/lockon/panel-img-min.jpg",
      },
    
      members: [
        {
          key: "hyunbin",
          name: "유현빈",
          position: "게임 개발자",
          phone: "010-8993-0728",
          email: "dndb0728@gmail.com",
          profile: "developer/lockon/profile-hyunbin.png",
          intro: "https://youtu.be/g10iLzk0Mrc?si=HSTKIQem7ClrZSwy"
        },
        {
          key: "giwon",
          name: "이기원",
          position: "게임 개발자",
          phone: "010-2200-2833",
          email: "shion9910@naver.com",
          profile: "developer/lockon/profile-giwon.png",
          intro: "https://youtu.be/YnjsK3atVCk?si=6kMSwCRg6bt8Ug6h"
        }
      ],
  
      about:
        "‘Gun & Fire’는 단순한 조작을 활용한 플레이어의 전략 및 반사신경을 끊임없이 몰려오는 적들로 하여금 시험하는 슈팅 액션 캐쥬얼 게임으로 다양한 아이템과 무기, 시련을 헤쳐나가면서 올라가는 점수, 적들의 공격을 통한 긴장감 이 세가지 요소로 플레이어에게 도전욕구를 자극하는 게임을 제안합니다.",
  
      phone: "010-8993-0728",
      email: "dndb0728@gmail.com",
    },

    // 디자이너
    {
      id: "des-01",
      category: "Designer",
      major: "Multimedia",
  
      name: "노민지",
      role: "L.POINT",
      position: "디자이너",
  
      images: {
        product: "designer/nohminji/product-img.jpg",
        profile: "designer/nohminji/profile-img.png",
        panel: "designer/nohminji/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/cHjx8x9bVb4?si=uRVMoqI4e-Qla-eI",
        intro: "https://youtu.be/GBzQE1JIOqg?si=l2HdFUtzo5AK580O",
      },
  
      about:
        "L.POINT 리뉴얼은 명확성, 일관성, 유희성 기반의 경험 중심 리워드 플랫폼으로의 진화를 목표합니다. 기존의 단순 적립·사용을 넘어, 데이터 기반 초개인화 UX와 참여형 루프 구조를 결합합니다. 이를 통해 탐색-참여-재사용이 순환되는 구조를 완성하여, 사용자의 일상 속에서 브랜드 충성도와 참여율을 높이는 차세대 리워드 허브가 되고자 합니다.",
  
      phone: "010 9404 5995",
      email: "nononomin28@kakao.com",
    },

    {
      id: "des-02",
      category: "Designer",
      major: "Multimedia",
  
      name: "박현주",
      role: "롯데백화점",
      position: "디자이너",
  
      images: {
        product: "designer/parkhyeonju/product-img.jpg",
        profile: "designer/parkhyeonju/profile-img.png",
        panel: "designer/parkhyeonju/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/czGeQ9Rz3Qw?si=RqbddrhjuSbdFgSx",
        intro: "https://youtu.be/kk12NEijPzU?si=OwcRxt9cPc3nE7yJ",
      },
  
      about:
        "백화점 시장은 온라인 성장과 디지털 전환의 가속화로 사용자의 구매 여정이 빠르게 변화하고 있으며,개인의 취향과 경험을 중시하는 소비 흐름이 확산되고 있습니다. 이러한 변화에 따라 기존의 '쇼핑을 위한 디지털 정보 서비스 채널'을 넘어, 온 오프라인의 경계를 허물고 브랜드 경험과 개인화 탐색을 통해 사용자 맞춤형 콘텐츠를 제공하는 라이프스타일 플랫폼을 제안합니다.",
  
      phone: "010-9632-0718",
      email: "pphhjj04@gmail.com",
    },

    {
      id: "des-03",
      category: "Designer",
      major: "Multimedia",
  
      name: "이지수",
      role: "밀크T&Tspoon",
      position: "디자이너",
  
      images: {
        product: "designer/leejisoo/product-img.jpg",
        profile: "designer/leejisoo/profile-img.png",
        panel: "designer/leejisoo/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/xMqreEshKhw?si=VTlQfUMAJw4fDITi",
        intro: "https://youtu.be/mstqKsfue3c?si=S918imGFurBRfqBg",
      },
  
      about:
        "밀크T 4세대 진화는 AI 맞춤을 넘어선 사용자 주도형 구조로의 전환을 목표합니다. 이에 학습자가 AI 조력자와 함께 학습 목표 및 경로를 능동적으로 설계해 주도성을 확보하고, 학습 흐름에 따른 정교한 AI 개입으로 실시간 몰입 환경을 구축하며, 학부모에게 AI 스토리텔링 요약 리포트를 제공해 신뢰를 구축하는 초개인화 학습 플랫폼을 제안합니다.",
  
      phone: "010-9549-9320",
      email: "dlwltn9320@kakao.com",
    },

    // 마케터
    {
      id: "mar-01",
      category: "Marketer",
      major: "Multimedia",
  
      name: "이아연",
      role: "하이브",
      position: "브랜드 마케팅 기획자",
  
      images: {
        product: "marketer/leeayeon/product-img.jpg",
        profile: "marketer/leeayeon/profile-img.png",
        panel: "marketer/leeayeon/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/wOu7bPmd9XQ?si=ex3KAA0Ts46pEG4s",
        intro: "https://youtu.be/uE7Lc9QLXo8?si=q67O_NcOWPxiy_y5",
      },
  
      about:
        "본 제안서는 하이브의 4세대 리브랜딩 전략을 다룹니다. 72%에 달하는 소비형 팬 활동을 연결 참여 경험 중심으로 전환하는 것이 핵심입니다. 이를 통해 팬들에게 새로운 몰입 경험 제공과 유대감을 형성하고 세부 전략으로 Your World 신규 슬로건 및 브랜드 필름, 위버스 LIVE UI 개편, HYBE 단체 콘서트, 아티스트 개인 채널 신설 등을 제안합니다. ",
  
      phone: "010-7797-5954",
      email: "ayeon4157@kakao.com",
    },

    {
      id: "mar-02",
      category: "Marketer",
      major: "Multimedia",
  
      name: "오제훈",
      role: "블루오션",
      position: "브랜드 마케팅 기획자",
  
      images: {
        product: "marketer/ohjeahun/product-img.jpg",
        profile: "marketer/ohjeahun/profile-img.png",
        panel: "marketer/ohjeahun/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/hAGVvoXs6O8?si=Jp30gy4SeVV0uu_N",
        intro: "https://youtu.be/j22XyKraxuk?si=wLoQ3X_zaC75RzyT",
      },
  
      about:
        "틱톡 블루오션에이전시는 브랜드 마케팅, 크리에이터 매칭, 콘텐츠 운영을 통합한 스마트 인플루언서 관리 플랫폼입니다. 실시간 성과 모니터링과 AI 트렌드 분석으로 광고 효율과 콘텐츠 경쟁력을 높이고, 관리자 중심 통합 관리로 캠페인 효율성과 만족도를 극대화합니다. 데이터 기반 운영으로 틱톡 생태계 내 브랜드-크리에이터 상생 모델을 구현하고자 합니다.",
  
      phone: "010-8011-5690",
      email: "wpgns0311@naver.com",
    },

    //영상 기획자
    {
      id: "vid-01",
      category: "Video Producer",
      major: "Video Media",
  
      name: "강지헌",
      role: "GS25",
      position: "영상 기획자",
  
      images: {
        product: "videoplanning/kangjiheon/product-img.jpg",
        profile: "videoplanning/kangjiheon/profile-img.png",
        panel: "videoplanning/kangjiheon/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/4uvTrVVMhPw?si=2oSn9q-UUE8bJDCv",
        intro: "https://youtu.be/sWSJqUyyYtg?si=cJFL3y5B6G-tk7ez",
      },
  
      about:
        "GS25는 GS리테일이 운영하는 국내 편의점 시장 브랜드 평판 1위 브랜드로, MZ세대를 타겟으로 트렌디한 이미지를 구축해왔습니다. 하지만 고객의 '선택 장애' 고민을 해결할 명확한 솔루션이 부족하다고 느꼈습니다. 이에 '요원 GS'라는 위트 있는 캐릭터가 등장하고, '확실한 조합'을 추천하여 '실패 없는 만족'을 선사하는 브랜디드 코믹 드라마를 제안합니다.",
  
      phone: "010-8998-3871",
      email: "rkdwlgjs123@gmail.com",
    },

    {
      id: "vid-02",
      category: "Video Producer",
      major: "Video Media",
  
      name: "고성준",
      role: "질레트",
      position: "영상 기획자",
  
      images: {
        product: "videoplanning/kosungjoon/product-img.jpg",
        profile: "videoplanning/kosungjoon/profile-img.png",
        panel: "videoplanning/kosungjoon/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/Y4gXkP-fBM8?si=W1TvO9kdC8W12TNM",
        intro: "https://youtu.be/7yrS1DY8LUY?si=IaOPCSjdWX-_0hcW",
      },
  
      about:
        "질레트는 세계 1위 면도기 브랜드로서 이미 그 기술력과 신뢰성을 입증받았습니다. 본 프로젝트는 이러한 브랜드 지위를 더욱 공고히 하는 동시에, F1의 속도와 정밀함을 메타포로 활용해 질레트의 브랜드 철학을 감각적이고 역동적인 스토리로 재해석합니다. 이를 통해 단순한 면도기가 아닌 ‘퍼포먼스, 그 이상을 면도하다’는 질레트의 철학을 각인시키고자 제안합니다.",
  
      phone: "010-8964-8154",
      email: "ksjoon8904@gmail.com",
    },

    {
      id: "vid-03",
      category: "Video Producer",
      major: "Video Media",
  
      name: "권민서",
      role: "하루상식",
      position: "영상 기획자",
  
      images: {
        product: "videoplanning/kwonminseo/product-img.jpg",
        profile: "videoplanning/kwonminseo/profile-img.png",
        panel: "videoplanning/kwonminseo/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/wFZ4-lLstco?si=QExXFzw8jQiNDLbU",
        intro: "https://youtu.be/XutfYCEquC4?si=vz6uhQychynx7RZQ",
      },
  
      about:
        "'하루상식'은 자극적인 콘텐츠 속에서 낭비되기 쉬운 1분을 가장 가치 있는 시간으로 바꾸는 교육 숏폼 콘텐츠로, 매일 새로운 주제로 복잡한 지식, 생활 상식 등을 단순 나열이 아닌 핵심 압축을 통해 전달합니다. 직관적인 시각화와 친근한 톤앤매너를 통해 이해하기 쉬우면서도 가장 효율적인 지식 습득 경험을 제공하는 새로운 상식 콘첸츠를 제안합니다.",
  
      phone: "010-5439-0938",
      email: "ohk930@gmail.com",
    },

    {
      id: "vid-04",
      category: "Video Producer",
      major: "Video Media",
  
      name: "김도희",
      role: "다시 쓰는 지도",
      position: "영상 기획자",
  
      images: {
        product: "videoplanning/kimdohee/product-img.jpg",
        profile: "videoplanning/kimdohee/profile-img.png",
        panel: "videoplanning/kimdohee/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/v8WRUnCFSxA?si=h-k40r4xBkaABhmj",
        intro: "https://youtu.be/3qsyMkXg3go?si=GmyYXW8JQKAgH1og",
      },
  
      about:
        "〈다시 쓰는 지도〉는 인구 소멸 위기 지역의 버려진 공간을 재생해 사람이 머무는 지역으로 만드는 프로젝트 예능입니다. 출연진이 지역의 자원과 이야기를 기반으로 체류형 인프라를 구축하고 새로운 로컬 거점을 조성하는 과정을 담습니다. 이 프로그램은 소멸이 아닌 시작을 기록하며 지속 가능한 변화를 제안하는 로컬 재생 콘텐츠입니다.",
  
      phone: "010-2551-7530",
      email: "doh0128@naver.com",
    },

    {
      id: "vid-05",
      category: "Video Producer",
      major: "Video Media",
  
      name: "김성일",
      role: "휴먼레시피",
      position: "영상 기획자",
  
      images: {
        product: "videoplanning/kimseongil/product-img.jpg",
        profile: "videoplanning/kimseongil/profile-img.png",
        panel: "videoplanning/kimseongil/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/i5FavKld66s?si=nTHKqSlCw7RU17dB",
        intro: "https://youtu.be/DV7mMOycwAk?si=urm21VGSPeeysefZ",
      },
  
      about:
        "우리는 매일 누군가와 말을 주고받으며 살아갑니다. 그 안에서 관계를 어렵게 만드는 건, 말의 내용이 아니라, 말의 방식입니다. 단 1분, “말하는 법”을 바꾸면 관계가 달라집니다. 오늘날 사람들은 끊임없이 대화하지만, 많은 이들이 ‘말’을 신경 쓰지 못해 상처를 주고받습니다. 휴먼 레시피는 그 상처를 메우는 ‘1분 대화법 솔루션’으로 휴먼 레시피 채널을 제안합니다.",
  
      phone: "010-7103-2927",
      email: "rlatjd0303@naver.com",
    },

    {
      id: "vid-06",
      category: "Video Producer",
      major: "Video Media",
  
      name: "김준홍",
      role: "TELLA",
      position: "영상 기획자",
  
      images: {
        product: "videoplanning/kimjoonhong/product-img.jpg",
        profile: "videoplanning/kimjoonhong/profile-img.png",
        panel: "videoplanning/kimjoonhong/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/Cv58hGSzjko?si=LOvou1niLPOMDlGr",
        intro: "https://youtu.be/1vC5h2tBK1Q?si=rCzav5vYfGh-3BI3",
      },
  
      about:
        "빠르게 소비되는 영상 시대, 사람들은 이야기의 여운을 잃어가고 있습니다. TELLA는 잊혀진 ‘문장 하나의 감정’을 다시 꺼내, AI를  활용하여 그것을 시각적 경험으로 번역하는 프로젝트입니다. 한 문장이 한 장면이 되고, 감정이 영상이 되는 순간, TELLA는 그 사이의 다리가 되어 책에 대한 또다른 접근으로 다가서길 제안합니다.",
  
      phone: "010-6545-2759",
      email: "wnsghd0128@naver.com",
    },

    {
      id: "vid-07",
      category: "Video Producer",
      major: "Video Media",
  
      name: "이유찬",
      role: "네이버페이",
      position: "영상 기획자",
  
      images: {
        product: "videoplanning/leeyuchan/product-img.jpg",
        profile: "videoplanning/leeyuchan/profile-img.png",
        panel: "videoplanning/leeyuchan/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/RnqfvJZKgRo?si=wa57xipqhVp1VWV1",
        intro: "https://youtu.be/2HRbLB9IVhw?si=bibQnv0k4XIoE3XK",
      },
  
      about:
        "네이버페이 광고는 '생활 속 루틴 완성'을 핵심 주제로, 스마트 소비 플랫폼으로 자리하고자 합니다. 캠페인은 노력 없이도 즉시 보상, 행동 최소화, 절약액 가시화로 반복 사용을 유도하며 , 혜택 허브로 인식 전환 및 충성도 강화를 제안합니다.",
  
      phone: "010-5059-3842",
      email: "fjadyvwh44@gmail.com",
    },

    {
      id: "vid-08",
      category: "Video Producer",
      major: "Video Media",
  
      name: "조용석",
      role: "KRAFTON",
      position: "영상 기획자",
  
      images: {
        product: "videoplanning/choyongseok/product-img.jpg",
        profile: "videoplanning/choyongseok/profile-img.png",
        panel: "videoplanning/choyongseok/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/OBWaDO7zYu8?si=6DRy8bSBDG3_aq0N",
        intro: "https://youtu.be/ooFXK7uJ2Do?si=vInS7zNimg8TWaS4",
      },
  
      about:
        "개별 게임 중심의 홍보는 브랜드 메시지의 일관성을 약화시키고, 플레이어 경험을 단편적으로 만듭니다. 이에 KRAFTON의 다양한 IP를 감정 서사로 통합해 기술이 아닌 감정 중심의 브랜드로 확장하며, 각 게임의 몰입을 하나의 리듬으로 연결한 통합형 시네마틱 포맷을 제안합니다. 이를 통해 브랜드 정체성을 강화하고, 모든 IP가 하나의 감정 세계로 이어지는 경험을 완성합니다.",
  
      phone: "010-4692-7541",
      email: "whdydtjr784@gmail.com",
    },

    // 3D 모델러
    {
      id: "3dm-01",
      category: "3D Modeler",
      major: "Video Media",
  
      name: "김미경",
      role: "GTFO (Get The Fuck Out)",
      position: "3D 모델러",
  
      images: {
        product: "3dmodeler/kimmigyeong/product-img.jpg",
        profile: "3dmodeler/kimmigyeong/profile-img.png",
        panel: "3dmodeler/kimmigyeong/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/hew_-HOxcr0?si=Nj7m5GnH0DR1_s8w",
        intro: "https://youtu.be/K8jH9E52hvA?si=FMCPQI4x7FVmJg4j",
      },
  
      about:
        "플레이어가 보다 독특하고 전략적인 플레이를 펼칠 수 있도록 맵 구조를 재구성하고, 이를 기반으로 새로운 구역을 제작하여 한정된 자원 내에서 몬스터 웨이브를 효과적으로 견뎌낼 수 있는 공간을 설계합니다. 이를 통해 전략적 방어와 지능적인 플레이를 유도하며, 전략적 선택과 리스크 관리가 공존하는 생존의 무대로 기능하도록 제안합니다.",
  
      phone: "010-8549-9936",
      email: "migyeong.happy@gmail.com",
    },

    {
      id: "3dm-02",
      category: "3D Modeler",
      major: "Video Media",
  
      name: "김현지",
      role: "폐병동 배경 모델링",
      position: "3D 모델러",
  
      images: {
        product: "3dmodeler/kimhyunji/product-img.jpg",
        profile: "3dmodeler/kimhyunji/profile-img.png",
        panel: "3dmodeler/kimhyunji/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/eJJ595cl7iw?si=SO6Nzx3vJoztG03H",
        intro: "https://youtu.be/-99OQRLBZ1s?si=_7XH109jKH041zju",
      },
  
      about:
        "본 작품은 기자라는 역할을 부여해 폐병동에 숨겨진 진실을 추적하는 몰입형 콘텐츠로 제작되었다. 단순히 공포를 자극하는 연출에 머무르지 않고, 병동 속 인물들의 감정과 서사, 그리고 그들이 남긴 흔적을 탐구하는 구조로 기획되었다. 이를 통해 3D 공간이 단순한 시각적 배경을 넘어 감정과 이야기를 전달하는 서사적 매개체로 확장될 수 있음을 제안합니다.",
  
      phone: "010-3982-2479",
      email: "gimj88759@kakao.com",
    },

    {
      id: "3dm-03",
      category: "3D Modeler",
      major: "Video Media",
  
      name: "백웅빈",
      role: "DNF Archer",
      position: "3D 모델러",
  
      images: {
        product: "3dmodeler/baekwoongbin/product-img.jpg",
        profile: "3dmodeler/baekwoongbin/profile-img.png",
        panel: "3dmodeler/baekwoongbin/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/sAyKUWT9dv4?si=7w600GzLtAaWzA0w",
        intro: "https://youtu.be/ROkEIfMbLcQ?si=F4ocP0TK8fC-wBFY",
      },
  
      about:
        "도트 기반의 캐릭터 ‘아처(Archer)’를 현대 3D 게임 스타일에 맞게 재구현한 캐릭터 모델링을 제안합니다. 원작의 감성을 그대로 이어가되, 하이퀄리티 3D 비주얼로 새로운 매력을 극대화하고자 합니다. 복장과 장비의 디테일을 정교하게 표현하여 캐릭터의 개성과 세계관을 강화하고, 3D 게임 환경에 최적화된 스타일을 완성했습니다.",
  
      phone: "010-8422-5707",
      email: "dndqls5707@naver.com",
    },

    {
      id: "3dm-04",
      category: "3D Modeler",
      major: "Video Media",
  
      name: "육서영",
      role: "Alien : Descent",
      position: "3D 모델러",
  
      images: {
        product: "3dmodeler/yookseoyoung/product-img.jpg",
        profile: "3dmodeler/yookseoyoung/profile-img.png",
        panel: "3dmodeler/yookseoyoung/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/7G9WoeRMKl4?si=rmX7aP8Qp4QljeDs",
        intro: "https://youtu.be/e_UuEdj4le0?si=RAEQpT5JJL4Nt8yW",
      },
  
      about:
        "에이리언 프로젝트는 폐쇄된 우주 정거장을 배경으로 미지의 생명체 흔적을 탐사하는 과정을 다룬 프로젝트입니다. 금속 구조물과 적막한 공간 연출로 고립된 공포와 탐사의 긴장감을 시각적으로 구현하고, 사실적 모델링과 조명 연출로 생명체의 흔적을 표현합니다. 공포와 호기심이 교차하는 서사를 바탕으로 시각적 완성도와 몰입감을 극대화한 경험을 제안합니다.",
  
      phone: "010-6489-2244",
      email: "sycs903@gmail.com",
    },

    // 3D 모션그래픽
    {
      id: "3dd-01",
      category: "Motion Graphic Designer",
      major: "Video Media",
  
      name: "임성준",
      role: "풀무원(한알육수)",
      position: "모션 그래픽 디자이너",
  
      images: {
        product: "3dmotiongraphic/limsungjun/product-img.jpg",
        profile: "3dmotiongraphic/limsungjun/profile-img.png",
        panel: "3dmotiongraphic/limsungjun/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/1kOPidI5zlQ?si=wNvIHD5OBhDa-lul",
        intro: "https://youtu.be/kYCPSCVZh80?si=MuW2l0zuRHX9qj7g",
      },
  
      about:
        "간편식 수요가 증가하고, 1인 가구가 늘어나며 소비자들은 빠른 조리 속에서도 믿고 먹을 수 있는 건강한 맛을 찾기 시작했습니다. 풀무원 코인육수는 한 알로 완성되는 간편함과 깊은 맛을 통해 현대인의 식탁에 편안함을 전달합니다. 풀무원 브랜드가 가진 신뢰를 통해 소비자가 안심할 수 있는 조리 경험을 느끼게 할 수 있도록 해당 기획을 제안했습니다.",
  
      phone: "010-4670-5638",
      email: "tjdwns0827@naver.com",
    },

    {
      id: "3dd-02",
      category: "Motion Graphic Designer",
      major: "Video Media",
  
      name: "최수빈",
      role: "바닐라코",
      position: "3D 모션그래픽 디자이너",
  
      images: {
        product: "3dmotiongraphic/choisubin/product-img.jpg",
        profile: "3dmotiongraphic/choisubin/profile-img.png",
        panel: "3dmotiongraphic/choisubin/panel-img-min.jpg",
      },
  
      links: {
        presentation: "https://youtu.be/9LDcuYmalJM?si=OiA9sL5gjeBe1AP9",
        intro: "https://youtu.be/paAcSo48vZ4?si=nWZaBcBVzSFMarIm",
      },
  
      about:
        "화장품 선택에서 패키지 디자인이 초기 주목과 기대 형성에 관여한다는 점에 착안해, 바닐라코 ‘에센스 스킨 핑크 쿠션’의 디자인 가치를 전면에 세운 모션 패키지를 제안합니다. 절제·균형·여백의 원칙으로 톤을 일관되게 유지하고, ‘선과 결, 핑크’의 시각 문법을 SNS·자사몰·매장 등 전 채널에 일관 적용해 첫인상 인지와 구매 고려 전환을 강화합니다.",
  
      phone: "010-5393-9395 ",
      email: "csb9395@naver.com",
    },

    // U300
    {
      id: "u300-01",
      category: "U300",
      major: "Team Project",
  
      name: "아스트",
      role: "VR을 활용한 외국인 K-푸드 체험 서비스",
      position: "김현정, 임형근, 허선범, 김진우, 황재하",
  
      images: {
        product: "u300/1/product-img.jpg",
        profile: "u300/1/profile-img.png",
        panel: "u300/1/panel-img-min.jpg",
      },
  
      about:
        "전 세계적으로 K-푸드의 인기가 높아지고 있지만, 외국인들이 한국 음식을 직접 체험할 기회는 여전히 부족합니다. 특히 해외 거주자는 식재료나 시설의 한계로 인해 실제 체험이 어렵고, 정보 접근 또한 제한적입니다. 이러한 문제를 해결하기 위해 일상 속에서 손쉽게 한국 음식 문화를 경험할 수 있는 체험형 서비스 시스템을 제안합니다.",
  
      phone: "010-9309-2066",
      email: "mary3033@naver.com",
    },

    {
      id: "u300-02",
      category: "U300",
      major: "Team Project",
  
      name: "뉴월드",
      role: "새터민 사회적 참여를 위한\n바리스타 직업 가상 체험제작",
      position: "이아연 ,김도희, 이지수, 임성준, 최수빈",
  
      images: {
        product: "u300/2/product-img.jpg",
        profile: "u300/2/profile-img.png",
        panel: "u300/2/panel-img-min.jpg",
      },
  
      about:
        "새터민은 경력 부족과 교육비 부담, 오프라인 실습의 한계로 구직에 어려움을 겪습니다. 이에 '뉴월드'는 남한 내 수요가 높은 바리스타 직무를 XR(확장 현실) 기반으로 교육하는 서비스를 개발해, 이들의 직무 역량을 높이고 시공간 제약 없는 기회를 제공할 것을 제안합니다.",
  
      phone: "010-7797-5954",
      email: "ayeon4157@kakao.com",
    },

    {
      id: "u300-03",
      category: "U300",
      major: "Team Project",
  
      name: "MediCheck",
      role: "젊은 세대가 XR을 통해 시니어의 삶을 체험하며\n 노후 준비의 중요성을 공감하는 서비스",
      position: "구본희, 노민지, 박수진, 박현주, 이현정",
  
      images: {
        product: "u300/3/product-img.jpg",
        profile: "u300/3/profile-img.png",
        panel: "u300/3/panel-img-min.jpg",
      },
  
      about:
        "현대사회는 고령화와 정신적 건강 악화, 웰빙 트렌드 확산으로 신체·정신 회복을 위한 체험형 서비스의 필요성이 커지고 있습니다. 세대 간 교류를 통한 심리 안정과 신체 회복이 새로운 복지 가치로 부상하고 있습니다. 이에 본 프로젝트는 기술과 체험을 결합한 맞춤형 웰니스 솔루션으로 세대가 공감할 수 있는 인간 중심의 건강 경험을 제안합니다.",
  
      phone: "010-3608-7855",
      email: "bons011207@naver.com",
    },

    {
      id: "u300-04",
      category: "U300",
      major: "Team Project",
  
      name: "안전제일",
      role: "어린이를 위한 가상 현실 (VR) 안전 교육 시뮬레이터",
      position: "김성일, 김수민, 박원빈, 박세웅, 최은빈",
  
      images: {
        product: "u300/4/product-img.jpg",
        profile: "u300/4/profile-img.png",
        panel: "u300/4/panel-img-min.jpg",
      },
  
      about:
        "최근 VR 기술의 눈부신 발전은 교육 분야에 새로운 가능성을 보여주고 있습니다. 특히, 어린이들의 안전 교육 분야에서는 VR 기술을 활용한 교육 방법이 점점 느는 추세이고, 기존의 이론 중심의 안전 교육은 아이들의 흥미를 유발하고 오랫동안 기억하기 어려운 한계를 가지고 있기 때문에 직접 체험하고, 안전 수칙을 익힐 수 있는 시뮬레이터 개발을 제안합니다.",
  
      phone: "010-7103-2927",
      email: "rlatjd0303@naver.com",
    },

    {
      id: "u300-05",
      category: "U300",
      major: "Team Project",
  
      name: "FrenchFries",
      role: "VR 기반 외국인의 언어 적응과 문화 이해를\n 돕는 체험형 한국어 학습 서비스",
      position: "고성준, 김준홍, 유현빈, 이인준, 최혁주",
  
      images: {
        product: "u300/5/product-img.jpg",
        profile: "u300/5/profile-img.png",
        panel: "u300/5/panel-img-min.jpg",
      },
  
      about:
        "글로벌 시대에 한국을 찾는 외국인의 수는 꾸준히 증가하고 있지만, 실제 생활 속에서 한국어를 사용하는 데에는 여전히 어려움이 존재합니다. 특히 편의점이나 버스 등 일상적 상황에서는 언어적 실수에 대한 두려움과 낯선 환경이 학습의 장벽이 됩니다. 이에 VR 환경을 활용해 실생활 한국어를 자연스럽게 익히는 체험형 학습 서비스를 제안합니다.",
  
      phone: "010-7942-6502",
      email: "injoon0526@kakao.com",
    },

    {
      id: "u300-06",
      category: "U300",
      major: "Team Project",
  
      name: "에헷콩",
      role: "XR/AR을 활용한 몰입형여행 네비게이션 서비스",
      position: "김현지, 김미경, 육서영",
  
      images: {
        product: "u300/6/product-img.jpg",
        profile: "u300/6/profile-img.png",
        panel: "u300/6/panel-img-min.jpg",
      },
  
      about:
        "휠체어 사용자 등 이동 약자를 위한 맞춤형 정보 제공과 여행지 사전 체험이 가능한 XR/AR 기반 몰입형 네비게이션 서비스 구현을 목표로 합니다. 기존 네비게이션은 이동 약자의 특수한 이동조건을 충분히 반영하지 못해 불편과 위험이 지속되고 있고, 이를 개선하기 위해 맞춤형 동선 안내와 사전 여행 체험이 가능한 네비게이션 서비스를 제안합니다.",
  
      phone: "010-3982-2479",
      email: "gimj88759@kakao.com",
    },

    {
      id: "u300-07",
      category: "U300",
      major: "Team Project",
  
      name: "스테어스",
      role: "청각장애인XR직업체험솔루션",
      position: "이지혁, 추강현, 백웅빈, 강지헌, 이기원",
  
      images: {
        product: "u300/7/product-img.jpg",
        profile: "u300/7/profile-img.png",
        panel: "u300/7/panel-img-min.jpg",
      },
  
      about:
        "청각장애인을 위한 XR 기반 직무체험 솔루션을 제안합니다. 본 솔루션은 VR 환경에서 시각 중심의 직무훈련 콘텐츠를 제공하며, 자막·아이콘·애니메이션 등을 통해 정보 접근성과 몰입도를 높입니다. 사용자의 훈련 이력을 기반으로 개인 맞춤형 콘텐츠를 추천하고, 결과 분석을 통해 취업 연계까지 가능한 실용적 교육 시스템입니다.",
  
      phone: "010-4967-4220",
      email: "dlwlgur15@kakao.com",
    },

    {
      id: "u300-08",
      category: "U300",
      major: "Team Project",
  
      name: "트리오",
      role: "다문화 가정을 위한 가상현실 한국문화체험 서비스",
      position: "문태환, 진천규, 오제훈",
  
      images: {
        product: "u300/8/product-img.jpg",
        profile: "u300/8/profile-img.png",
        panel: "u300/8/panel-img-min.jpg",
      },
  
      about:
        "VR 전통문화체험 서비스는 한복을 직접 보고 움직이며 체험할 수 있는 몰입형 콘텐츠로, 사용자가 한복의 형태·색·착용 방식을 자연스럽게 이해하도록 돕습니다. 또한 체험 후 다문화가족지원센터 등과 연계해 실제 한복체험 행사로 이어지는 온·오프라인 연계 구조를 통해 지속적 참여와 문화 공감 확산을 목표로 제안합니다.",
  
      phone: "010-9292-4732",
      email: "xoghksehdsp@kakao.com",
    },

    {
      id: "u300-09",
      category: "U300",
      major: "Team Project",
  
      name: "브릿지",
      role: "저소득층 아동을 위한\n실감형 3D 교육 콘텐츠 서비스 기획",
      position: "신수영, 곽민지, 유회창, 김지현",
  
      images: {
        product: "u300/9/product-img.jpg",
        profile: "u300/9/profile-img.png",
        panel: "u300/9/panel-img-min.jpg",
      },
  
      about:
        "제안 내용은 경제적 제약과 디지털 격차로 학습 기회를 제한받는 아동을 위해, VR 기반 실감형 3D 콘텐츠를 활용한 학습 서비스를 제안합니다. 아동이 가상공간에서 주제를 직접 체험하며 능동적으로 학습하도록 설계해 교육 참여와 흥미를 높이고, 평등한 학습 환경을 조성하고자 합니다.",
  
      phone: "010-8318-3900",
      email: "notablyf@naver.com",
    },

    {
      id: "u300-10",
      category: "U300",
      major: "Team Project",
  
      name: "형광팬",
      role: "교통약자 이동지원 호출 시스템",
      position: "김은서, 조용석, 이유찬, 최현아",
  
      images: {
        product: "u300/10/product-img.jpg",
        profile: "u300/10/profile-img.png",
        panel: "u300/10/panel-img-min.jpg",
      },
  
      about:
        "교통약자와 고령자를 위한 실시간 호출·VR 시뮬레이션 기반 스마트 이동지원 플랫폼 구축을 목표로, 기술과 배려가 공존하는 포용적 교통 환경을 구현. 사용자는 가상공간에서 이동을 직관적으로 체험하고, 운영자는 데이터로 효율을 개선해 공공 서비스의 디지털 전환과 이동권 보장을 함께 실현할 것을 제안합니다.",
  
      phone: "010-6844-4750",
      email: "rlaeunseo@kakao.com",
    },

    //멀티 팀플
    {
      id: "mt-1",
      category: "M-Team",
      major: "Team Project",
  
      name: "아스트",
      role: "스마트 주거 환경 통합관리 서비스",
      position: "황재하,김진우,김현정,허선범,임형근",
  
      images: {
        product: "mt/1/product-img.jpg",
        profile: "mt/1/profile-img.png",
        panel: "mt/1/panel-img-min.jpg",
      },
  
      about:
        "주거 공간은 단순 거주를 넘어, 사용자가 직접 제어·관리하는 데이터 기반 생활 플랫폼으로 전환 중입니다. 이에 아이파크는 맞춤 제어와 생활 자동화를 아우르고, 입주부터 일상 관리까지 끊김 없는 경험을 제공하는 스마트 허브로 진화합니다. 결과적으로 사용자는 효율과 신뢰를 갖춘 프리미엄 여정과 체계적 관리를 자연스럽게 누리는 스마트 주거를 제안합니다.",
  
      phone: "010-6430-0607",
      email: "ys010607@kakao.com",
    },

    {
      id: "mt-2",
      category: "M-Team",
      major: "Team Project",
  
      name: "안전계단",
      role: "운전자 중심의 시선·집중도 기반\n아반떼 인포테이먼트 서비스",
      position: "김수민, 박원빈, 이지혁, 최은빈, 추강현",
  
      images: {
        product: "mt/2/product-img.jpg",
        profile: "mt/2/profile-img.png",
        panel: "mt/2/panel-img-min.jpg",
      },
  
      about:
        "현대차 인포테인먼트는 기능 중심 설계로 운전 중 인지·조작성이 낮고, OTA·AI·AR 연동도 부족해 경험 향상에 한계가 있다. 통합 UI·시선 UX로 안전성과 편의성을 높이고, 데이터 기반 클라우드 OTA로 지속 업데이트되는 운전자 중심 플랫폼을 제안합니다.",
  
      phone: "010-5594-4585",
      email: "dnjsqls0620@kakao.com",
    },

    {
      id: "mt-3",
      category: "M-Team",
      major: "Team Project",
  
      name: "미녀와 야수",
      role: "고려대학교 안암병원 베리어프리 키오스크",
      position: "구본희, 노민지, 박수진, 박현주, 이현정",
  
      images: {
        product: "mt/3/product-img.jpg",
        profile: "mt/3/profile-img.png",
        panel: "mt/3/panel-img-min.jpg",
      },
  
      about:
        "현대 대학병원은 복잡한 진료 절차와 다양한 환자층으로 인해 사용자가 동선을 이해하고 정보를 파악하기 어렵습니다. 기존 키오스크는 접수와 대기 안내에 집중해 효율을 높였지만, 전체 여정 파악과 인지 부담 완화에는 한계가 있습니다. 이에 본 프로젝트는 행동과 인지 흐름을 기반으로, 자연스럽고 직관적인 진료 경험을 제공하는 차세대 키오스크 환경을 제안합니다.",
  
      phone: "010-3608-7855",
      email: "bons011207@naver.com",
    },

    {
      id: "mt-4",
      category: "M-Team",
      major: "Team Project",
  
      name: "모노리브",
      role: "관람객의 여정 전반을 연결하는\n사용자 중심의 스마트 키오스크",
      position: "최혁주, 이아연, 이지수, 이인준, 유현빈",
  
      images: {
        product: "mt/4/product-img.jpg",
        profile: "mt/4/profile-img.png",
        panel: "mt/4/panel-img-min.jpg",
      },
  
      about:
        "국립중앙박물관은 해마다 방문객이 증가하며 대표 문화공간으로 자리 잡았으나, 기존 키오스크는 노후화된 시스템과 제한된 기능으로 관람객의 다양한 요구를 충족하기 어렵습니다. 특히 외국인·고령자·장애인을 위한 접근성과 정보 제공의 한계가 두드러집니다. 이에 실시간 안내 등 스마트 전시 서비스를 제안합니다.",
  
      phone: "010-6387-2473",
      email: "gurwn0904@naver.com",
    },

    {
      id: "mt-5",
      category: "M-Team",
      major: "Team Project",
  
      name: "문방구",
      role: "롯데백화점 키오스크 제안서",
      position: "문태환, 곽민지, 신수영",
  
      images: {
        product: "mt/5/product-img.jpg",
        profile: "mt/5/profile-img.png",
        panel: "mt/5/panel-img-min.jpg",
      },
  
      about:
        "기존의 백화점 키오스크가 단순한 정보 제공 중심이었다면, 새로운 롯데백화점 키오스크는 ‘고객 중심의 스마트 경험 플랫폼’으로 진화합니다. 키오스크와 APP을 유기적으로 연동함으로써분산된 정보 구조와 복잡한 동선을 단순화하고, 사용자의 실제 이용 맥락에 따라 자연스럽게 반응하는차세대 통합형 백화점 키오스크를 제안합니다.",
  
      phone: "010-9292-4732",
      email: "xoghksehdsp@kakao.com",
    },
  ];